import { render } from "./smart-goal.vue?vue&type=template&id=35abf942"
import script from "./smart-goal.vue?vue&type=script&lang=js"
export * from "./smart-goal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__